export const API_REQUEST_TYPES = {
  GET: 'GET',
};
